/*
*   table with database for managers connection
*
* appears in <div class="database__main" id="managerbase" data-controller="managerbase"></div>

*/


import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import Twig from 'twig'
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css'
import 'select2/dist/js/select2.min'
import 'select2/dist/css/select2.min.css'
import {Modal} from "bootstrap";
import datetimepicker from 'jquery-datetimepicker'
import mask from 'jquery-mask-plugin'
import { jsPDF } from "jspdf";
import {Html5QrcodeScanner} from "html5-qrcode";




export default class extends Controller {
    table;
    WhoIs;
    doctorsList = [];
    doctors = [];
    managers = [];
    storeCode;
    allPurchasesData = new Map();
    NotAddedList = [];
    ClickCounter = 0;
    QrResult = '';

    tableSchedule;
    fullDoctorList = [];
    dataBaseScheduleStart;
    dataBaseScheduleFinish;
    dataBaseScheduleCurrent = new Date();

    initialize(){
        super.initialize();
    }

    /* !!!!!!!! GO TO PAGE !!!!!!!!!!!!!! */
    // go to the database page for managers
    showManagerbasePage(){
        $('#titlePageBox').remove();
        $('#authorization').remove();
        $('#managerbase').remove();
        $('#form-clientcreation').remove();
        $('#doctors-schedule').remove();
        $('#doctorsall-schedule').remove();
        $('.xdsoft_datetimepicker').remove();
        $('#headerContentTitle').html('Список клиентов');
        $('#template__header').after('' +
            '<div class="d-none d-sm-flex align-items-center title-page__box" id="titlePageBox">' +
            /*'<h1 class="title-page">Список клиентов</h1>' +*/
            '<div class="ms-auto" data-controller="managerbase">' +
            '<button type="button" class="btn btn-light btnIcon" data-action="click->managerbase#showDoctorSchedule"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> Расписание врачей</button>' +
            '<button type="button" class="btn btn-light btnIcon" data-action="click->managerbase#addNewClient"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg> Добавить клиента</button>' +
            '</div>' +
            '</div>' +
            '<div class="container-fluid database__main" id="managerbase" data-controller="managerbase"></div>');
    }

    //go to the form page - add a new client
    addNewClient() {
        this.checkToken();
        $('#titlePageBox').remove();
        $('#authorization').remove();
        $('#managerbase').remove();
        $('#form-clientcreation').remove();
        $('#doctors-schedule').remove();
        $('#doctorsall-schedule').remove();
        $('.xdsoft_datetimepicker').remove();
        $('#headerContentTitle').html('Добавить клиента');
        $('#template__header').after('' +
            '<div class="d-none d-sm-flex align-items-center title-page__box" id="titlePageBox">' +
            /*'<h1 class="title-page">Данные клиента</h1>' +*/
            '<div class="ms-auto" data-controller="managerbase">' +
            '<button type="button" class="btn btn-light btnIcon" data-action="click->managerbase#showDoctorSchedule"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> Расписание врачей</button>' +
            '<button type="button" class="btn btn-light btnIcon" data-action="click->managerbase#showManagerbasePage"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg> Список клиентов</button>' +
            '</div>' +
            '</div>' +
            '<div class="container-fluid form__main" id="form-clientcreation" data-controller="form-clientcreation"></div>');
    }

    //go to the form page - edit the client profile
    editClient(event) {
        this.checkToken();
        $('#titlePageBox').remove();
        $('#authorization').remove();
        $('#managerbase').remove();
        $('#form-clientcreation').remove();
        $('#doctors-schedule').remove();
        $('#doctorsall-schedule').remove();
        $('.xdsoft_datetimepicker').remove();
        $('#headerContentTitle').html('Редактировать данные клиента');
        $('#template__header').after('' +
            '<div class="d-none d-sm-flex align-items-center title-page__box" id="titlePageBox">' +
            /*'<h1 class="title-page">Данные клиента</h1>' +*/
            '<div class="ms-auto" data-controller="managerbase">' +
            '<button type="button" class="btn btn-light btnIcon" data-action="click->managerbase#showDoctorSchedule"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> Расписание врачей</button>' +
            '<button type="button" class="btn btn-light btnIcon" data-action="click->managerbase#showManagerbasePage"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg> Список клиентов</button>' +
            '</div>' +
            '</div>' +
            '<div class="container-fluid form__main" id="form-clientcreation" data-controller="form-clientcreation" data-clientPhone="'+ event.params.clientphone +'"></div>');
    }

    // go to the doctors schedule for managers
    showDoctorSchedule(){
        $('#titlePageBox').remove();
        $('#authorization').remove();
        $('#managerbase').remove();
        $('#form-clientcreation').remove();
        $('#doctors-schedule').remove();
        $('#doctorsall-schedule').remove();
        $('.xdsoft_datetimepicker').remove();
        $('#headerContentTitle').html('Расписание врачей');
        $('#template__header').after('' +
            '<div class="d-none d-sm-flex align-items-center title-page__box" id="titlePageBox">' +
            /*'<h1 class="title-page">Расписание врачей</h1>' +*/
            '<div class="ms-auto" data-controller="managerbase">' +
            '<button type="button" class="btn btn-light btnIcon" data-action="click->managerbase#showAllDoctorSchedule"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> Расписание всех врачей </button>' +
            '<button type="button" class="btn btn-light btnIcon" data-action="click->managerbase#showManagerbasePage"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg> Список клиентов</button>' +
            '<button type="button" class="btn btn-light btnIcon" data-action="click->managerbase#addNewClient"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg> Добавить клиента</button>' +
            '</div>' +
            '</div>' +
            '<div class="container-fluid database__main" id="doctors-schedule" data-controller="doctors-schedule"></div>');
    }

    // go to the ALL  schedule for managers
    showAllDoctorSchedule(){
        $('#titlePageBox').remove();
        $('#authorization').remove();
        $('#managerbase').remove();
        $('#form-clientcreation').remove();
        $('#doctors-schedule').remove();
        $('#doctorsall-schedule').remove();
        $('.xdsoft_datetimepicker').remove();
        $('#headerContentTitle').html('Расписание всех врачей');
        $('#template__header').after('' +
            '<div class="d-none d-sm-flex align-items-center title-page__box" id="titlePageBox">' +
            /*'<h1 class="title-page">Расписание всех врачей</h1>' +*/
            '<div class="ms-auto" data-controller="managerbase">' +
            '<button type="button" class="btn btn-light btnIcon" data-action="click->managerbase#showDoctorSchedule"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> Расписание врачей </button>' +
            '<button type="button" class="btn btn-light btnIcon" data-action="click->managerbase#showManagerbasePage"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg> Список клиентов</button>' +
            '<button type="button" class="btn btn-light btnIcon" data-action="click->managerbase#addNewClient"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg> Добавить клиента</button>' +
            '</div>' +
            '</div>' +
            '<div class="container-fluid database__main" id="doctorsall-schedule" data-controller="doctorsall-schedule"></div>');
    }
    /* !!!!!!!! end GO TO PAGE !!!!!!!!!!!!!! */

    //checking authorization
    checkToken(){
        let token = sessionStorage.getItem('token');
        if (token !== null ){
            this.WhoIs = api.WhoIs();
            if(this.WhoIs.status === 500) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('userId');
                let nameVar = Twig.twig({ref: "authorization"}).render({});
                $('#authorization').html(nameVar)
            }
        } else {
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('userId');
            let nameVar = Twig.twig({ref: "authorization"}).render({});
            $('#authorization').html(nameVar)
        }
    }

    //show-hide additional info - generate a line waiting for the output
    showHideAddInfo(event){
        let tr = $(event.target).closest('tr');
        let row = this.table.row(tr);
        if (row.child.isShown()) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass('shown');
        } else {
            // Open this row
            row.child(this.showAddInfo(row.data(), event.params.id)).show();
            tr.addClass('shown');
        }


    }

    //we pull up additional info for people - status, amount of purchases, bonuses
    showAddInfo(d, id){
        $(".database-addInfo").click(function(event) {
            let clickId = event.target.id;
        });
        let status  =  api.statusClient(d.token);
        let bonus   =  api.bonusClient(d.token);
        let doctors =  api.doctorList('all');
        let currentUserId = sessionStorage.getItem('userId');
        let doctorId = d.created_by;
        let doctorInfo = doctors.find(el => el.StaffID === doctorId);
        let statusName;
        let statusSum;
        let bonusBirthday;
        let bonussales;
        let doctorFio;
        let doctorSalon;
        if(status !== undefined){
            statusName = status.status.GrupAd;
            statusSum = status.status.ClientSaves.toFixed(2) +'₸';
        } else {
            statusName = "нет данных";
            statusSum = "нет данных";
        }
        if (doctorInfo !== undefined){
            doctorFio = doctorInfo.Name;
            doctorSalon = doctorInfo.StoreCode;
        } else {
            doctorFio = "нет данных";
            doctorSalon = "нет данных";
        }

        if(bonus !== undefined){
            bonusBirthday = bonus.birthdayBonus.toFixed(2)+'₸';
            bonussales = bonus.salesBonus.toFixed(2)+'₸';
        } else {
            bonusBirthday = "нет данных";
            bonussales = "нет данных";
        }
        let clientRegisterDateInfo = new Date(d.created_at).toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty", hour: "2-digit", minute: "2-digit"});

        let stringId = id;
        return (
            '<div class="clientAddInfo">' +
                '<ul class="clientAddInfo__list">' +
                    '<li class="clientAddInfo__item">' +
                        '<span class="clientAddInfo__title">Статус клиента:</span><strong class="clientAddInfo__data">' + statusName + '</strong>' +
                    '</li>' +
                    '<li class="clientAddInfo__item">' +
                        '<span class="clientAddInfo__title">Сумма накоплений:</span><strong class="clientAddInfo__data">' + statusSum + '</strong>' +
                    '</li>' +
                    '<li class="clientAddInfo__item">' +
                        '<span class="clientAddInfo__title">Бонус за покупки:</span><strong class="clientAddInfo__data">' + bonussales + '</strong>' +
                    '</li>' +
                    '<li class="clientAddInfo__item">' +
                        '<span class="clientAddInfo__title">Бонусы на день рождения:</span><strong class="clientAddInfo__data">' + bonusBirthday  + '</strong>' +
                    '</li>' +
                '</ul>' +

                '<ul class="clientAddInfo__list">' +
                    '<li class="clientAddInfo__item">' +
                    '<span class="clientAddInfo__title">Дата регистрации:</span><strong class="clientAddInfo__data">' + clientRegisterDateInfo + '</strong>' +
                    '</li>' +
                    '<li class="clientAddInfo__item">' +
                    '<span class="clientAddInfo__title">Кто зарегистрировал:</span><strong class="clientAddInfo__data">' + doctorFio + '</strong>' +
                    '</li>' +
                    '<li class="clientAddInfo__item">' +
                    '<span class="clientAddInfo__title">Салон:</span><strong class="clientAddInfo__data">' + doctorSalon + '</strong>' +
                    '</li>' +
                    '<li class="clientAddInfo__item clientAddInfo__item-btn">' +
                    '<button class="btn btn-primary" style="margin-right: 50px" type="button" data-action="click->managerbase#showUserPurchases" data-managerbase-id-param="'+stringId+'">покупки</button>' +
                    '<button class="btn btn-primary" type="button" data-action="click->managerbase#showUserRecipe" data-managerbase-id-param="'+stringId+'">рецепт</button>' +
                    '</li>' +
                '</ul>' +

                /* modal purchases stringId*/
                '<div class="modal fade" id="modalPurchasesUser-'+stringId+'" tabindex="-1" aria-hidden="true">' +
                    '<div class="modal-dialog modal-lg modal-dialog-centered">' +
                        '<div class="modal-content">' +
                            '<div class="modal-header"><h5 class="modal-title">Покупки: '+d.client_name+' '+d.client_surname+'</h5>' +
                            '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>' +
                            '</div>' +
                            '<div class="modal-body">' +
                                '<div class="modalPurchasesUser__box">' +
                                    '<table class="table table-bordered table-striped modalPurchasesUser__table">' +
            '<thead><tr><th>Дата покупки</th><th>Бренд/Модель</th><th>артикул</th></tr></thead>' +
            '<tbody id="modalPurchasesUserContent-'+stringId+'"></tbody>' +
            '</table>' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
            '</div>' +
                /* END modal purchases */

            /* modal recipe */
            '<div class="modal fade" id="modalRecipeUser-'+stringId+'" tabindex="-1" aria-hidden="true">' +
                '<div class="modal-dialog modal-lg modal-dialog-centered">' +
                    '<div class="modal-content">' +
                        '<div class="modal-header"><h5 class="modal-title">Рецепт: '+d.client_name+' '+d.client_surname+'' +
                        '</h5><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>' +
                        '</div>' +
                        '<div class="modal-body" id="modalRecipeUserContent-'+stringId+'">' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            /* END modal recipe */
            '</div>'
        );
    }

    showUserPurchases(event){

        let showUserPurchasesModal = new Modal(document.getElementById('modalPurchasesUser-' + event.params.id +''));

        let modalPurchasesUserTable = api.getPurchases(event.params.id);
        if (modalPurchasesUserTable !== null){
            let modalPurchasesUserContent = 'modalPurchasesUserContent-'+event.params.id;
            modalPurchasesUserTable.forEach((item)=>{
                let purchasesDate = new Date(item.sales_date).toLocaleString('ru-KZ', { timeZone: 'UTC', dateStyle:'short', timeStyle:'short' });

                $('#'+modalPurchasesUserContent).append('' +
                    '<tr>' +
                    '<td>'+purchasesDate+'</td>' +
                    '<td><a href="https://shop.actualoptic.kz/index.php?route=product/product&product_id='+item.product_id+'" target="_blank">'+item.brand+' '+item.model+'</a></td>' +
                    '<td>'+item.sku+'</td>' +
                    '</tr>')
            })
        } else {
            $('#modalPurchasesUser-'+event.params.id +' .modal-body').html('' +
                '<div class="alert alert-warning">У клиента еще не было покупок</div>')
        }

        showUserPurchasesModal.show();

    }

    removeNull(receipt){
        for(let k in receipt){
            if (receipt[k] === null){
                receipt[k] = "0"
            }
            if(typeof receipt[k] === 'object'){
                this.removeNull(receipt[k])
            }
        }
    }

     showUserRecipe(event){
        let modalRecipeContent = $('#modalRecipeUserContent-'+event.params.id);
        modalRecipeContent.html('');

         let userListProfiles =  api.profileList(event.params.id);
         let receiptGlass = [];
         let receiptLens;
         let receiptDoctor;
         let receiptDate;
         let doctorName;
         if (userListProfiles === null){
             let userFormDataWeb = api.getReceiptFromWeb(event.params.id);
              if(userFormDataWeb === null){
                 $('#modalRecipeUserContent-'+event.params.id).append('' +
                     '<div class="alert alert-warning">У клиента еще нет рецепта</div>');
             } else {
                 receiptDate = Date.parse(userFormDataWeb.receipt.AddDate);
                 receiptDate = new Date(receiptDate).toLocaleDateString('ru-RU');

                  receiptDoctor = userFormDataWeb.receipt.DRAdSoyad;
                  doctorName = receiptDoctor;

                  receiptGlass[0] = userFormDataWeb.receipt;

                 let checkLens = false;
                 Object.entries(userFormDataWeb.lens.OD).forEach(([key,ODvalue])=>{
                     if (ODvalue !== null){
                         checkLens = true
                     }
                 })
                 Object.entries(userFormDataWeb.lens.OS).forEach(([key,OSvalue])=>{
                     if (OSvalue !== null){
                         checkLens = true
                     }
                 })
                 if (checkLens){
                     receiptLens = userFormDataWeb.lens;
                 }

             }



         }  else {
                let userFormData = api.getAnketa(userListProfiles[0].id);
                receiptGlass = userFormData.ReceiptGlass;
                receiptLens = userFormData.ReceiptLens;
                receiptDoctor = userFormData.CreatedBy;

                 receiptDate = Date.parse(userFormData.CreatedAt);
                 receiptDate = new Date(receiptDate).toLocaleDateString('ru-RU');

                 doctorName = api.getDoctor(receiptDoctor);
                 doctorName = doctorName.Name;
         }
                let self =  this;
                    if(receiptGlass[0] !== undefined){
                        //строим таблицу рецепт на очки
                        receiptGlass.forEach(function(item, index) {
                            self.removeNull(item);

                            index++;
                            let footingItemGen = item.footing;
                            let footingtext;
                            switch (footingItemGen)
                            {
                                case "bi":
                                    footingtext = 'BI (основание внутрь)'
                                    break;
                                case "bo":
                                    footingtext = 'BO (основание к виску)'
                                    break;
                                case "bu":
                                    footingtext = 'BU (основание вверх)'
                                    break;
                                case "bd":
                                    footingtext = 'BD (основание вниз)'
                                    break;
                                case undefined:
                                    footingtext = ''
                                    break;
                            }

                            modalRecipeContent.append('' +
                                '<div>' +
                                '<div class="row mt-2">\n' +
                                '<div class="col-sm-12  mb-3  print__title">'+receiptDate+'</div> ' +
                                '' +
                                '       <strong class="col-sm-12 print__title">Рецепт на очки #'+ ((index)) +'</strong>\n' +
                                '    </div>' +
                                '       <table class="table mt-1 border-bottom-0 table-print newReceiptGlassBox'+index+'">\n' +
                                '                        <tr>\n' +
                                '                            <td class="border-bottom-0 receipt-td-220">\n' +
                                '                                <strong>Visus OD:</strong>\n' +
                                '                                <span class="receipt-box-100" id="receiptGlass'+index+'OD-visus-before">'+item.OD.visus.before+'</span>\n' +
                                '                            </td>\n' +
                                '                            <td class="border-bottom-0 receipt-td-220">\n' +
                                '                                <strong>Visus OS:</strong>\n' +
                                '                                <span id="receiptGlass'+index+'OS-visus-before">'+item.OS.visus.before+'</span>\n' +
                                '                            </td>\n' +
                                '<td class="border-bottom-0 receipt-td-right"><strong class="col-sm-12 form-label mt-3" id="footing'+index+'">'+footingtext+'</strong></td>' +
                                '                        </tr>\n' +
                                '                    </table>' +
                                '                        <table class="table table-bordered vision-table print__table table-print mt-1 newReceiptGlassBox'+index+'">\n' +
                                '\n' +
                                '                            <tr>\n' +
                                '                                <th class=""></th>\n' +
                                '                                <th class="vision-table-bg">sph</th>\n' +
                                '                                <th class="vision-table-bg">cyl</th>\n' +
                                '                                <th class="vision-table-bg">ax</th>\n' +
                                '                                <th class="vision-table-bg">Add</th>\n' +
                                '                                <th class="vision-table-bg">pr1</th>\n' +
                                '                                <th class="vision-table-bg">bas</th>\n' +
                                '                                <th class="vision-table-bg">pr2</th>\n' +
                                '                                <th class="vision-table-bg">bas</th>\n' +
                                '                            </tr>\n' +
                                '\n' +
                                '                            <tr>\n' +
                                '                                <td class="vision-table-title">OD</td>\n' +
                                '                                <td>\n' +
                                '                                    <span class="" id="receiptGlass'+index+'OD-sph"  >'+item.OD.sph+'</span>\n' +
                                '                                </td>\n' +
                                '                                <td>\n' +
                                '                                    <span class="" id="receiptGlass'+index+'OD-cyl" >'+item.OD.cyl+'</span>\n' +
                                '                                </td>\n' +
                                '                                <td>\n' +
                                '                                    <span class="" id="receiptGlass'+index+'OD-ax" >'+item.OD.ax+'</span>\n' +
                                '                                </td>\n' +
                                '                                <td>\n' +
                                '                                    <span class="" id="receiptGlass'+index+'OD-add">'+item.OD.add+'</span>\n' +
                                '                                </td>\n' +
                                '                                <td>\n' +
                                '                                    <span class="" id="receiptGlass'+index+'OD-pr1">'+item.OD.pr1+'</span>\n' +
                                '                                </td>\n' +
                                '                                <td>\n' +
                                '                                    <span class="" id="receiptGlass'+index+'OD-bas1">'+item.OD.bas1+'</span>\n' +
                                '                                </td>\n' +
                                '                                <td>\n' +
                                '                                    <span class="" id="receiptGlass'+index+'OD-pr2">'+item.OD.pr2+'</span>\n' +
                                '                                </td>\n' +
                                '                                <td>\n' +
                                '                                    <span class="" id="receiptGlass'+index+'OD-bas2">'+item.OD.bas2+'</span>\n' +
                                '                                </td>\n' +
                                '                            </tr>\n' +
                                '                            <tr>\n' +
                                '                                <td class="vision-table-title">OS</td>\n' +
                                '                                <td>\n' +
                                '                                    <span class="" id="receiptGlass'+index+'OS-sph"  >'+item.OS.sph+'</span>\n' +
                                '                                </td>\n' +
                                '                                <td>\n' +
                                '                                    <span class="" id="receiptGlass'+index+'OS-cyl" >'+item.OS.cyl+'</span>\n' +
                                '                                </td>\n' +
                                '                                <td>\n' +
                                '                                    <span class="" id="receiptGlass'+index+'OS-ax" >'+item.OS.ax+'</span>\n' +
                                '                                </td>\n' +
                                '                                <td>\n' +
                                '                                    <span class="" id="receiptGlass'+index+'OS-add">'+item.OS.add+'</span>\n' +
                                '                                </td>\n' +
                                '                                <td>\n' +
                                '                                    <span class="" id="receiptGlass'+index+'OS-pr1">'+item.OS.pr1+'</span>\n' +
                                '                                </td>\n' +
                                '                                <td>\n' +
                                '                                    <span class="" id="receiptGlass'+index+'OS-bas1">'+item.OS.bas1+'</span>\n' +
                                '                                </td>\n' +
                                '                                <td>\n' +
                                '                                    <span class="" id="receiptGlass'+index+'OS-pr2">'+item.OS.pr2+'</span>\n' +
                                '                                </td>\n' +
                                '                                <td>\n' +
                                '                                    <span class="" id="receiptGlass'+index+'OS-bas2">'+item.OS.bas2+'</span>\n' +
                                '                                </td>\n' +
                                '\n' +
                                '                            </tr>\n' +
                                '                        </table>\n' +
                                '       <table class="table mt-1 receipt-tab-500 table-print newReceiptGlassBox'+index+'">\n' +
                                '                        <tr>\n' +
                                '                            <td class="border-bottom-0 receipt-td-220">\n' +
                                '                                <strong>Visus OD:</strong>\n' +
                                '                                <span class="receipt-box-100" id="receiptGlass'+index+'OD-visus-after">'+item.OD.visus.after+'</span>\n' +
                                '                            </td>\n' +
                                '                            <td class="border-bottom-0 receipt-td-220">\n' +
                                '                                <strong>Visus OS:</strong>\n' +
                                '                                <span id="receiptGlass'+index+'OS-visus-after">'+item.OS.visus.after+'</span>\n' +
                                '                            </td>\n' +
                                '                        </tr>\n' +
                                '                    </table>' +
                                '         <table class="table mt-1 receipt-tab-800 newReceiptGlassBox'+index+'">\n' +
                                '                        <tr>\n' +
                                '                            <td class="border-bottom-0 receipt-td-200">\n' +
                                '                                <strong>РЦ даль OD:</strong>\n' +
                                '                                <span id="receiptGlass'+index+'OD-rc-distance">'+item.OD.rc.distance+'</span>\n' +
                                '                            </td>\n' +
                                '                            <td class="border-bottom-0 receipt-td-200">\n' +
                                '                                <strong>РЦ даль OS:</strong>\n' +
                                '                                <span id="receiptGlass'+index+'OS-rc-distance">'+item.OS.rc.distance+'</span>\n' +
                                '                            </td>\n' +
                                '                            <td class="border-bottom-0 receipt-td-200">\n' +
                                '                                <strong>РЦ близь OD:</strong>\n' +
                                '                                <span id="receiptGlass'+index+'OD-rc-near">'+item.OD.rc.near+'</span>\n' +
                                '                            </td>\n' +
                                '                            <td class="border-bottom-0 receipt-td-200">\n' +
                                '                                <strong>РЦ близь OS:</strong>\n' +
                                '                                <span id="receiptGlass'+index+'OS-rc-near">'+item.OS.rc.near+'</span>\n' +
                                '                            </td>\n' +
                                '                        </tr>\n' +
                                '                    </table>' +
                                ' <div class="col-sm-12 mt-4 table-print newReceiptGlassBox'+index+'">\n' +
                                '                        <strong class="col-sm-12  form-label mt-3">Рекомендуемая оптическая линза с покрытием: </strong>\n' +
                                '                        <span id="recommendedCoatedLens'+index+'">'+item.recommendedCoatedLens+'</span>\n' +
                                '                    </div>' +
                                '                    <div class="col-sm-12 mt-1 receiptGlassLensValidation__box'+index+' print__checkbox" >\n' +
                                '                        <table class="table">\n' +
                                '                            <tr>' +
                                '<td>' +
                                '                                    <div class="form-check">\n' +
                                '                                        <input type="checkbox" value="distanse" class="form-check-input receiptGlassLensValidation d-none" name="receiptGlass[lenses]" id="lenses'+index+'-distanse" disabled="disabled" >\n' +
                                '                                        <label class="form-check-label anketa-checkbox" for="lenses'+index+'-distanse">Даль</label>\n' +
                                '                                    </div>\n' +
                                '\n' +
                                '                                    <div class="form-check">\n' +
                                '                                        <input type="checkbox" value="reader" class="form-check-input receiptGlassLensValidation d-none" name="receiptGlass[lenses]" id="lenses'+index+'-reader" disabled="disabled" >\n' +
                                '                                        <label class="form-check-label anketa-checkbox" for="lenses'+index+'-reader">Близь</label>\n' +
                                '                                    </div>\n' +
                                '\n' +

                                '</td>' +
                                '<td>' +
                                '                                    <div class="form-check">\n' +
                                '                                        <input type="checkbox" value="constance" class="form-check-input receiptGlassLensValidation d-none" name="receiptGlass[lenses]" id="lenses'+index+'-constance" disabled="disabled" >\n' +
                                '                                        <label class="form-check-label anketa-checkbox" for="lenses'+index+'-constance">Постоянное ношение</label>\n' +
                                '                                    </div>\n' +
                                '                                    <div class="form-check">\n' +
                                '                                        <input type="checkbox" value="bifocal" class="form-check-input receiptGlassLensValidation d-none" name="receiptGlass[lenses]" id="lenses'+index+'-bifocal"disabled="disabled">\n' +
                                '                                        <label class="form-check-label anketa-checkbox" for="lenses'+index+'-bifocal">Бифокальные</label>\n' +
                                '                                    </div>\n' +

                                '</td>' +
                                '<td>' +
                                '                                    <div class="form-check">\n' +
                                '                                        <input type="checkbox" value="single" class="form-check-input receiptGlassLensValidation d-none" name="receiptGlass[lenses]" id="lenses'+index+'-single" disabled="disabled" >\n' +
                                '                                        <label class="form-check-label anketa-checkbox" for="lenses'+index+'-single">Однофокальные</label>\n' +
                                '</div>\n' +
                                '                                    <div class="form-check">\n' +
                                '                                        <input type="checkbox" value="progressive" class="form-check-input receiptGlassLensValidation d-none" name="receiptGlass[lenses]" id="lenses'+index+'-progressive" disabled="disabled">\n' +
                                '                                        <label class="form-check-label anketa-checkbox" for="lenses'+index+'-progressive">Прогрессивные</label>\n' +
                                '                                    </div>\n' +
                                '</td>' +
                                '<td>' +
                                '<div class="form-check">\n' +
                                '                                        <input type="checkbox" value="provision" class="form-check-input receiptGlassLensValidation d-none" name="receiptGlass[lenses]" id="lenses'+index+'-provision" disabled="disabled" >\n' +
                                '                                        <label class="form-check-label anketa-checkbox" for="lenses'+index+'-provision">Курс Provision</label></div>' +
                                '<div class="form-check">\n' +
                                '                                        <input type="checkbox" value="office" class="form-check-input receiptGlassLensValidation d-none" name="receiptGlass[lenses]" id="lenses'+index+'-office" disabled="disabled">\n' +
                                '                                        <label class="form-check-label anketa-checkbox" for="lenses'+index+'-office">Офисные</label></div>' +
                                '</td>' +
                                '                            </tr>\n' +
                                '                        </table>\n' +
                                '                    </div>' +
                                '</div>' +
                                '</div>');
                            //убираем нули из значений
                            $('.newReceiptGlassBox'+index+' span').each(function(){
                                if($(this).text() === "0"){
                                    $(this).text("");
                                }
                            });

                            let receiptGenGlassODSph = Number(item.OD.sph);
                            if(receiptGenGlassODSph > 0){
                                $('#receiptGlass'+index+'OD-sph').prepend('+')
                            }


                            let receiptGenGlassOSSph = Number(item.OS.sph);
                            if(receiptGenGlassOSSph > 0){
                                $('#receiptGlass'+index+'OS-sph').prepend('+')
                            }

                            //Рецепт на очки очки линзы список checkbox
                            let glassLensesGen = item.lenses;
                            if(glassLensesGen !== undefined){
                                glassLensesGen.forEach((item)=>{
                                    $('.receiptGlassLensValidation__box'+index+' input[value="' + item +'"]').prop('checked', true)
                                });
                            }


                        })/* конец цикла генерации рецептов*/

                        //строим рекомендации
                        let recommendations = receiptGlass[0].recommendations;
                        let notes = receiptGlass[0].notes;
                        if (recommendations !== null){
                            modalRecipeContent.append('' +
                                ' <div class="col-sm-12">\n' +
                                '            <strong class="form-label">Рекомендации:</strong>\n' +
                                '            <span id="receiptGlass-recommendations">'+recommendations+'</span>\n' +
                                '</div>' +
                                '')
                        }
                        if (notes !== null){
                            modalRecipeContent.append('' +
                                ' <div class="col-sm-12 mt-1">\n' +
                                '            <strong class="form-label">Примечания:</strong>\n' +
                                '            <span id="receiptGlass-notes">'+notes+'</span>\n' +
                                '</div>');
                        }
                    }




                //строим таблицу рецепт контактные линзы
                if(receiptLens !== null && receiptLens !== undefined) {
                    self.removeNull(receiptLens);

                    let ReceiptLensODSph = Number(receiptLens.OD.sph);
                    let ReceiptLensODSphInfo = '';
                    if(ReceiptLensODSph > 0){
                        ReceiptLensODSphInfo = "+"
                    }
                    if(ReceiptLensODSph === 0){
                        ReceiptLensODSph = ''
                    }
                    let receiptLensODCyl = Number(receiptLens.OD.cyl)
                    if(receiptLensODCyl === 0){
                        receiptLensODCyl = ''
                    }
                    let receiptLensODAx = Number(receiptLens.OD.ax)
                    if(receiptLensODAx === 0){
                        receiptLensODAx = ''
                    }
                    let receiptLensODAdd = Number(receiptLens.OD.add)
                    if(receiptLensODAdd === 0){
                        receiptLensODAdd = ''
                    }
                    let receiptLensODBc = Number(receiptLens.OD.bc)
                    if(receiptLensODBc === 0){
                        receiptLensODBc = ''
                    }
                    let receiptLensODDia = Number(receiptLens.OD.dia)
                    if(receiptLensODDia === 0){
                        receiptLensODDia = ''
                    }
                    let ReceiptLensOSSph = Number(receiptLens.OS.sph);
                    let ReceiptLensOSSphInfo = '';
                    if(ReceiptLensOSSph > 0){
                        ReceiptLensOSSphInfo = "+"
                    }
                    if(ReceiptLensOSSph === 0){
                        ReceiptLensOSSph = ''
                    }
                    let receiptLensOSCyl = Number(receiptLens.OS.cyl);
                    if(receiptLensOSCyl === 0){
                        receiptLensOSCyl = ''
                    }
                    let receiptLensOSAx = Number(receiptLens.OS.ax);
                    if(receiptLensOSAx === 0){
                        receiptLensOSAx = ''
                    }
                    let receiptLensOSAdd = Number(receiptLens.OS.add);
                    if(receiptLensOSAdd === 0){
                        receiptLensOSAdd = ''
                    }
                    let receiptLensOSBc = Number(receiptLens.OS.bc);
                    if(receiptLensOSBc === 0){
                        receiptLensOSBc = ''
                    }
                    let receiptLensOSDia = Number(receiptLens.OS.dia);
                    if(receiptLensOSDia === 0){
                        receiptLensOSDia = ''
                    }
//Посадка МКЛ выборка radio
                    let fitSCL = receiptLens.fit;
                    let fitSCLItem;
                    switch (fitSCL)
                    {
                        case "abrupt":
                            fitSCLItem = 'крутая'
                            break;
                        case "flat":
                            fitSCLItem = 'плоская'
                            break;
                        case "standard":
                            fitSCLItem = 'норма'
                            break;
                    }

                    modalRecipeContent.append('' +
                        '<div class="row recipeContactLensBox" style="padding-top: 20px;padding-bottom: 20px">' +
                        '<strong class="col-sm-12 print__title">Рецепт контактные линзы</strong>' +
                        '<table class="table table-bordered vision-table mt-2" id="recipeContactLens-'+event.params.id+'">' +
                        ' <thead>\n' +
                        '            <tr>\n' +
                        '                <th class=""></th>\n' +
                        '                <th class="vision-table-bg">\n' +
                        '                    sph\n' +
                        '                </th>\n' +
                        '                <th class="vision-table-bg">\n' +
                        '                    cyl\n' +
                        '                </th>\n' +
                        '                <th class="vision-table-bg">\n' +
                        '                    ax\n' +
                        '                </th>\n' +
                        '                <th class="vision-table-bg">\n' +
                        '                    Add\n' +
                        '                </th>\n' +
                        '                <th class="vision-table-bg">\n' +
                        '                    bc\n' +
                        '                </th>\n' +
                        '                <th class="vision-table-bg">\n' +
                        '                    Dia\n' +
                        '                </th>\n' +
                        '            </tr>\n' +
                        '            </thead>' +
                        ' <tbody>\n' +
                        '            <tr>\n' +
                        '                <td class="vision-table-title">OD</td>\n' +
                        '                <td>\n' +
                        '                    <span class="receiptLensOD-sph">'+ReceiptLensODSphInfo+''+ReceiptLensODSph+'</span>\n' +
                        '                </td>\n' +
                        '                <td>\n' +
                        '                    <span class="receiptLensOD-cyl">'+receiptLensODCyl+'</span>\n' +
                        '                </td>\n' +
                        '                <td>\n' +
                        '                    <span class="receiptLensOD-ax">'+receiptLensODAx+'</span>\n' +
                        '                </td>\n' +
                        '                <td>\n' +
                        '                    <span class="receiptLensOD-add">'+receiptLensODAdd+'</span>\n' +
                        '                </td>\n' +
                        '                <td>\n' +
                        '                    <span class="receiptLensOD-bc">'+receiptLensODBc+'</span>\n' +
                        '                </td>\n' +
                        '                <td><span class="receiptLensOD-dia">'+receiptLensODDia+'</span>\n' +
                        '                </td>\n' +
                        '            </tr>\n' +
                        '            <tr>\n' +
                        '                <td class="vision-table-title">OS</td>\n' +
                        '                <td>\n' +
                        '                    <span class="receiptLensOS-sph">'+ReceiptLensOSSphInfo+' '+ReceiptLensOSSph+'</span>\n' +
                        '                </td>\n' +
                        '                <td>\n' +
                        '                    <span class="receiptLensOS-cyl">'+receiptLensOSCyl+'</span>\n' +
                        '                </td>\n' +
                        '                <td>\n' +
                        '                    <span class="receiptLensOS-ax">'+receiptLensOSAx+'</span>\n' +
                        '                </td>\n' +
                        '                <td>\n' +
                        '                    <span class="receiptLensOS-add">'+receiptLensOSAdd+'</span>\n' +
                        '                </td>\n' +
                        '                <td><span class="receiptLensOS-bc">'+receiptLensOSBc+'</span>\n' +
                        '                </td>\n' +
                        '                <td><span class="receiptLensOS-dia">'+receiptLensOSDia+'</span>\n' +
                        '                </td>\n' +
                        '            </tr>\n' +
                        '            <tr>\n' +
                        '                <td colspan="7">\n' +
                        '                    <ul class="list-inline receiptLensTypeList" id="receiptLensType-'+event.params.id+'"></ul>\n' +
                        '                </td>\n' +
                        '            </tr>\n' +
                        '            </tbody>' +

                        '</table>' +

                        '<table class="table">\n' +
                        '            <tr>\n' +
                        '                <td style="width:200px"><strong>Наименование</strong></td>\n' +
                        '                <td><span class="receiptLens-name">'+receiptLens.name+'</span></td>\n' +
                        '            </tr>\n' +
                        '            <tr>\n' +
                        '                <td><strong>Режим замены:</strong></td>\n' +
                        '                <td><span class="receiptLens-mode">'+receiptLens.mode+'</span></td>\n' +
                        '            </tr>\n' +
                        '            <tr>\n' +
                        '                <td><strong>Режим ношения:</strong></td>\n' +
                        '                <td><span class="receiptLens-wearing">'+receiptLens.wearing+'</span></td>\n' +
                        '            </tr>\n' +
                        '        </table>'

                    )

                    if (receiptLens.type !== null){
                        let receiptLensTypeList = receiptLens.type;
                        let receiptLensTypeItem;
                        function receiptLensTypeName(name) {
                            switch (name)
                            {
                                case "hy":
                                    receiptLensTypeItem = 'Hy'
                                    break;
                                case "siHy":
                                    receiptLensTypeItem = 'Si-Hy'
                                    break;
                                case "torica":
                                    receiptLensTypeItem = 'Torica'
                                    break;
                                case "other":
                                    receiptLensTypeItem = 'Другие'
                                    break;
                            }
                        }
                        if (receiptLensTypeList !==null && receiptLensTypeList !== "0"){
                            receiptLensTypeList.forEach((item)=>{
                                receiptLensTypeName(item);
                                let typeOtherText;
                                if(receiptLensTypeItem === 'Другие'){
                                    typeOtherText = ' (' +receiptLens.typeOther+ ')'
                                } else {
                                    typeOtherText = ""
                                }
                                $('#receiptLensType-'+event.params.id).append('<li>' + receiptLensTypeItem + '' + typeOtherText+'</li>')
                            });
                        }

                    }


                }  //END строим таблицу рецепт контактные линзы



         if (receiptGlass[0] !== undefined){
             modalRecipeContent.append('' +
                 ' <div class="col-sm-12 mt-1">\n' +
                 '            <strong class="form-label">Диагноз:</strong>\n' +
                 '            <span class="receiptGlass-diagnosis">'+receiptGlass[0].diagnosis+'</span>\n' +
                 '</div>' +
                 '');

            if (receiptDoctor !== undefined){

                modalRecipeContent.append('' +
                    '        <div class="col-sm-12 mt-2">\n' +
                    '            <strong class="form-label">Доктор</strong>\n' +
                    '            <span class="createdBy">'+doctorName+'</span>\n' +
                    '        </div>' +
                    '')

            }





         }


        let showUserRecipeModal = new Modal(document.getElementById('modalRecipeUser-' + event.params.id +''));
        showUserRecipeModal.show();
    }

    //logout from authorization
    logout(){
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('userId');
        let nameVar = Twig.twig({ref: "authorization"}).render({});
        $('#authorization').html(nameVar)
    }

    //add an account for a client. result is token
    addCabinet(event){
        let cabinetBtn = $('#btnAddCabinet-'+event.params.idpatient);
        cabinetBtn.attr('disabled', 'disabled');
        self = this;
        $.ajax({
            type: "post",
            url: global.api_url + '/patient/cabinet/'+ event.params.idpatient,
            contentType: "application/json",
            success: function(data){
                cabinetBtn.addClass('hideElement').after('<span class="textExistСabinet"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg> Кабинет есть</span>');
                cabinetBtn.remove();
                self.table.row('tr').draw();
            },
            error: function (data){
                cabinetBtn.attr('disabled', false);
            }
        })
    }

    //request customer purchases
      loadPurchases(event){
          $('#sendMessageBtn-'+event.params.id).attr('disabled', 'disabled');
          $('#loadPurchases-'+event.params.id).html('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line></svg> Загружаю').removeClass('btn-datainfo').addClass('btn-edit loadingIconAnimate').attr('disabled', 'disabled');

          //request data, get response
          api.loadPurchasesSingle(event.params.token).done((result)=>{

              //success
              $('#sendMessageBtn-'+event.params.id).attr('disabled', false);
              $('#loadPurchases-'+event.params.id).html('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-datainfo"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg> Загрузить').removeClass('btn-edit loadingIconAnimate').addClass('btn-datainfo').attr('disabled', false);
              this.table.row('tr').draw();
          }).fail((error)=>{
              //error
              $('#sendMessageBtn-'+event.params.id).attr('disabled', false);
              $('#loadPurchases-'+event.params.id).html('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-datainfo"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg> Загрузить').removeClass('btn-edit loadingIconAnimate').addClass('btn-datainfo').attr('disabled', false);
              this.table.row('tr').draw();
              alert('Загрузка не удалась');
          });

    }

    //load new clients form WEB database
    loadNewClients() {
        $('#loadAllPurchases button').attr('disabled','disabled');

        $('#loadNewClients').html('' +
            '<span class="dashboard-loadbox__icon" id="dashboardLoadboxIcon">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-big icon-datainfo loading"><line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line></svg></span>' +
            '<ul class="dashboard-loadbox__process">\n' +
            '                    <li class="dashboard-loadbox__process-item">\n' +
            '                        <span class="dashboard-loadbox__process-text">Добавлено:</span>\n' +
            '                        <strong class="dashboard-loadbox__process-result" id="loadNewClientAdded"></strong>\n' +
            '                    </li>\n' +
            '                    <li class="dashboard-loadbox__process-item">\n' +
            '                        <span class="dashboard-loadbox__process-text">Пропущено:</span>\n' +
            '                        <strong class="dashboard-loadbox__process-result" id="loadNewClientMissed"></strong>\n' +
            '                    </li>\n' +
            '                </ul>')


        api.loadNewClients().done((result) => {
            //success
        }).fail((error) => {
            //error
            console.debug(error);
        });

          let refreshIntervalId = setInterval(() => {
            let result = api.loadStatusLoading();
            $('#loadNewClientAdded').text(result.Added);
            $('#loadNewClientMissed').text(result.NotAdded);
            //$('#loadNewClientDescription').text(result.Status);


            if (result.Status.indexOf('Finished') !== -1) {
                clearInterval(refreshIntervalId);

                if (result.NotAdded !== 0) {
                    this.NotAddedList = result.Details;
                    this.NotAddedList.shift();
                }

                $('#loadAllPurchases button').attr('disabled',false);

                $('#loadNewClients').append('<span class="dashboard-loadbox__close" data-action="click->managerbase#loadNewClientsClose"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="50" height="50" fill-rule="nonzero" xmlns:v="https://vecta.io/nano" class="icon"><path d="M39.52 32.16l-7.36 7.36L120.64 128l-88.48 88.48 7.36 7.36L128 135.36l88.48 88.48 7.36-7.36L135.36 128l88.48-88.48-7.36-7.36L128 120.64z" fill="#fff"/></svg></span>');
                $('#dashboardLoadboxIcon').html('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-big icon-datainfo"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>')
            }
        }, 50);


    }

    //create PDF for result of downloading new clients from WEB database
    pdfCreator(){
        // GENERATE PDF
        //dimensions in pt
        const pageWidth    = 595;
        const lineHeight   = 1.2;
        const marginRight  = 5;
        const maxLineWidth = pageWidth - (marginRight + 50);
        const fontSize     = 10;
        let   ptsPerInch   = 3;
        let oneLineHeight  = (fontSize * lineHeight) + ptsPerInch;
        const doc = new jsPDF({
            unit: "pt",
            lineHeight: lineHeight
        });
        doc.addFont("font/Montserrat-Regular.ttf", "Montserrat", "normal");
        doc.addFont("font/Montserrat-Bold.ttf", "MontserratBold", "normal");
        doc.setFontSize(fontSize);
        doc.setTextColor(0, 0, 0);

        // set reference points
        let topBasePoint = 30;
        let leftBasePoint = 30;
        let halfPagePoint = (pageWidth - leftBasePoint ) / 2;
        let logoWidth = 90;
        let logoHeight = 29;
        let topBaseClientTextPoint = (topBasePoint + logoHeight) + 15 ;

        // logo
        doc.addImage("img/actual-optic-logo-print.jpg", "JPEG", topBasePoint, leftBasePoint, logoWidth, logoHeight);

        //manager name string
        doc.setFont('MontserratBold');
        doc.text('Менеджер:', halfPagePoint, topBaseClientTextPoint);
        doc.setFont('Montserrat');
        doc.text(WhoIs.Name, halfPagePoint + 100, topBaseClientTextPoint);


        //current date and time
        doc.setFont('MontserratBold');
        doc.text('Дата, время:', halfPagePoint, topBaseClientTextPoint + oneLineHeight);
        doc.setFont('Montserrat');
        doc.text(new Date().toLocaleDateString('ru-KZ', { timeZone: "Asia/Almaty", hour: "2-digit", minute: "2-digit"}), halfPagePoint + 100, topBaseClientTextPoint);


        //generate file name
        let fileCreatorFio = WhoIs.UserName;
        let fileCreatorSalon = WhoIs.StoreCode;
        let fileCreatedAtDate = (new Date()).toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty", hour: "2-digit", minute: "2-digit"});
        doc.save(fileCreatorFio +"-fileCreatorSalon-"+fileCreatedAtDate+".pdf");
    }

    //close result of downloading new clients from WEB database
    loadNewClientsClose(){
        $('#loadNewClients').html('<button type="button" class="btn btn-light btnIcon" data-action="click->managerbase#loadNewClients"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg> загрузить новых клиентов из базы WEB</button>')
    }


    //load all purchases
    loadAllPurchases(){
        $('#loadNewClients button').attr('disabled','disabled');

        $('#loadAllPurchases').html('' +
            '<span class="dashboard-loadbox__icon" id="dashboardAllPurchasesIcon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-big icon-datainfo loading"><line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line></svg></span>' +
            '<ul class="dashboard-loadbox__process">' +
                '<li class="dashboard-loadbox__process-item">' +
                    '<span class="dashboard-loadbox__process-text">Добавлено счетов:</span>' +
            '<strong class="dashboard-loadbox__process-result" id="loadAllPurchasesAdded"></strong>' +
            '' +
                '</li>' +
            '</ul>')


        api.loadAllPurchases().done((result) => {
            //success
        }).fail((error) => {
            //error
            console.debug(error);
        });


        let refreshIntervalId = setInterval(() => {
            let result = api.loadAllPurchasesStatusLoading();
            this.allPurchasesData.set(result.PatientId, result);
            $('#loadAllPurchasesAdded').text((this.allPurchasesData.size) -1);

            if (result.PatientId === 0 && result.Status === 'finish'){
                clearInterval(refreshIntervalId);
                $('#loadNewClients button').attr('disabled',false);

                $('#loadAllPurchases').append('<span class="dashboard-loadbox__close" data-action="click->managerbase#loaddashboardAllPurchasesIconClose"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="50" height="50" fill-rule="nonzero" xmlns:v="https://vecta.io/nano" class="icon"><path d="M39.52 32.16l-7.36 7.36L120.64 128l-88.48 88.48 7.36 7.36L128 135.36l88.48 88.48 7.36-7.36L135.36 128l88.48-88.48-7.36-7.36L128 120.64z" fill="#fff"/></svg></span>');
                $('#dashboardAllPurchasesIcon').html('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-big icon-datainfo"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>')

            }
        }, 200);
    }

    //close result of downloading All Purchases from WEB database
    loaddashboardAllPurchasesIconClose(){
        $('#loadAllPurchases').html('<button type="button" class="btn btn-light btnIcon" data-action="click->managerbase#loadAllPurchases"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg> загрузить все покупки  из базы WEB</button>')
    }

    // send message to whatsapp
    sendMessageWhatsapp(event){
        let messageWA = $('#messageWA-'+event.params.id);
        let messagePush = $('#messagePush-'+event.params.id);

        messageWA.attr('disabled', 'disabled');
        messagePush.attr('disabled', 'disabled');

        let currentModalMessage = $('#sendMessage-'+event.params.id);
        let messageSend = $($('#messageSend-'+event.params.id)[0]).serializeObject();
        messageSend.client_id = Number(messageSend.client_id);
        messageSend = JSON.stringify(messageSend);

        let title = $('#messageTitle-'+event.params.id);
        let text = $('#messageText-'+event.params.id);
        if (title.val().length === 0){
            title.addClass('invalid');
            messageWA.attr('disabled', false);
            messagePush.attr('disabled', false);
        } else {
            title.removeClass('invalid');
        }

        if (text.val().length === 0){
            text.addClass('invalid');
            messageWA.attr('disabled', false);
            messagePush.attr('disabled', false);
        } else {
            text.removeClass('invalid');
        }

        if (text.val().length !== 0 && title.val().length !== 0){
            let result = api.sendMessageWhatsapp(messageSend);
            if (result === null){
                messageWA.attr('disabled', false);
                messagePush.attr('disabled', false);
                $('#sendMessage-'+event.params.id+' .modal-body ').prepend('<div class="alert alert-danger" role="alert">\n' +
                    'Сообщение не отправлено\n' +
                    '</div>');
                $('#sendMessage-'+event.params.id+' .alert ').delay(5000).slideUp(300)
            } else {
                messageWA.attr('disabled', false);
                messagePush.attr('disabled', false);
                $('#sendMessage-'+event.params.id+' .modal-body ').prepend('<div class="alert alert-success" role="alert">\n' +
                    'Сообщение отправлено в Whatsapp\n' +
                    '</div>');
                $('#sendMessage-'+event.params.id+' .alert ').delay(5000).slideUp(300)
            }
        }
     }

    // send a message in a push
    sendMessagePush(event){
        let messageWA = $('#messageWA-'+event.params.id);
        let messagePush = $('#messagePush-'+event.params.id);

        messageWA.attr('disabled', 'disabled');
        messagePush.attr('disabled', 'disabled');

        let currentModalMessage = $('#sendMessage-'+event.params.id);
        let messageSend = $($('#messageSend-'+event.params.id)[0]).serializeObject();
        messageSend.client_id = Number(messageSend.client_id);
        messageSend = JSON.stringify(messageSend);
        let title = $('#messageTitle-'+event.params.id);
        let text = $('#messageText-'+event.params.id);
        if (title.val().length === 0){
            title.addClass('invalid');
            messageWA.attr('disabled', false);
            messagePush.attr('disabled', false);
        } else {
            title.removeClass('invalid');
        }

        if (text.val().length === 0){
            text.addClass('invalid');
            messageWA.attr('disabled', false);
            messagePush.attr('disabled', false);
        } else {
            text.removeClass('invalid');
        }

        if (text.val().length !== 0 && title.val().length !== 0){
            let result = api.sendMessagePush(messageSend);
            if (result === null){
                messageWA.attr('disabled', false);
                messagePush.attr('disabled', false);
                $('#sendMessage-'+event.params.id+' .modal-body ').prepend('<div class="alert alert-danger" role="alert">\n' +
                    'Сообщение не отправлено\n' +
                    '</div>');
                $('#sendMessage-'+event.params.id+' .alert ').delay(5000).slideUp(300)
            } else {
                messageWA.attr('disabled', false);
                messagePush.attr('disabled', false);
                $('#sendMessage-'+event.params.id+' .modal-body ').prepend('<div class="alert alert-success" role="alert">\n' +
                    'Сообщение отправлено в Push\n' +
                    '</div>');
                $('#sendMessage-'+event.params.id+' .alert ').delay(5000).slideUp(300)
            }
        }
    }


    //clear form fields for messages when modal closes
    clearMessageForm(event){
        let title = $('#messageTitle-'+event.params.idmessageform);
        let text = $('#messageText-'+event.params.idmessageform);
        title.val('');
        text.val('');
    }

    //create a list of managers in a select with a filter
    getManagerList(){
        self = this;
        let storeDoctorList = [];

        this.doctorsList = $('#js-managers-list[name="managers[]"]').val();

        self.doctorsList.forEach((id)=>{
            let storeCode = self.managers.find((manager) => manager.StaffID.toString() === id).StoreCode;
                let filterlist = self.doctors.filter((val)=>{
                    return val.StoreCode === storeCode
                });

            storeDoctorList = storeDoctorList.concat(filterlist);

        });
        storeDoctorList.forEach((element)=>{
            this.doctorsList.push(element.StaffID.toString());
        });
        this.table.draw();
    }

    //create a list of doctors in the select
    getDoctorsList(){
        let currentDoctorId = sessionStorage.getItem('userId');
        let currentDoctorIdNum = Number(currentDoctorId);
        let jsDoctorList = $('#js-managers-list');

        if(this.doctors.length === 0){
            this.doctors = api.doctorList('doctor');
        }

        if(this.managers.length === 0){
            this.managers = api.doctorList('manager');

        }

        this.managers.forEach((item)=>{
            /* ЗАКРЫТО 07.2023 - ВЫВОД В ФИЛЬТР ДЕФОЛТНО ТЕКУЩЕГО ЮЗЕРА и в таблице ДЕФОЛТНО вывод пациентов из салона текущего юзера
            ЧТОБЫ ОТКРЫТЬ:
            1. РАСКОММЕНТИРОВАТЬ IF-ELSE
            2. удалить строку после IF-ELSE - jsDoctorList.append('<option value="'+item.StaffID+'">'+item.Name+' ('+item.StoreCode+')</option>');
            3. РАСКОММЕНТИРОВАТЬ строку //this.doctorsList = [currentDoctorId];
            4. удалить строку НИЖЕ раскоментированной -    this.doctorsList = [];
            */

           /* if (currentDoctorIdNum === item.StaffID){
                jsDoctorList.append('<option value="'+item.StaffID+'" selected="selected">'+item.Name+' ('+item.StoreCode+')</option>');
                this.storeCode = item.StoreCode;
            } else {
                jsDoctorList.append('<option value="'+item.StaffID+'">'+item.Name+' ('+item.StoreCode+')</option>');
            }*/
            jsDoctorList.append('<option value="'+item.StaffID+'">'+item.Name+' ('+item.StoreCode+')</option>');

        });

        jsDoctorList.select2({
            placeholder: 'Нажмите, чтобы выбрать салон/менеджера'
        });

        let storeDoctorList = this.doctors.filter((val)=>{
            //return val.StoreCode === this.storeCode

        });



        //this.doctorsList = [currentDoctorId];
        this.doctorsList = [];
        storeDoctorList.forEach((element)=>{
            this.doctorsList.push(element.StaffID.toString());
        });
    }


    //clean the filter
    clearFilter(){
        $('#js-managers-list').val(null).trigger('change');
        this.doctorsList = [];
        this.table.draw();
    }

    //clean the filter
    clearBigFilter(){
        $('#managerFilter-brand').val(null).trigger('change');
        $('#managerFilter-model').val(null).trigger('change');
        $('#managerFilter-start').val('');
        $('#managerFilter-finish').val('');
        /*this.doctorsList = [];
        this.table.draw();*/
    }


    //output database
    buildTable(){
        $.fn.dataTable.ext.errMode = 'none';
        self =  this;

        this.table = $('#managerbaseList').DataTable({
            language: {
                url: 'data/dataTables.ru.json'
            },
            serverSide: true,
            processing: true,

            ajax: {
                url: global.api_url + '/patient/datatable',
                headers: {'Authorization': 'Bearer '+ sessionStorage.getItem('token')},
                type: 'post',
                data: (data)=>{
                    if(self.doctorsList.length !== 0 ){
                        data.doctorFilter = self.doctorsList;
                    } else{
                        data.doctorFilter = null;
                    }
                    data.userType = 'manager';
                    return JSON.stringify(data);

                },
                contentType: "application/json",

                error: (error)=>{
                    console.debug(error);
                    /*  sessionStorage.removeItem('token');
                      sessionStorage.removeItem('userId');
                      document.location.reload();*/
                }
            },
            columns: [
                {
                    /*className: 'dt-control',*/
                    orderable: false,
                    searchable: false,
                    data: null,
                    render: ((data, type, full, meta)=>{
                        return '<span class="dt-control button-action database-addInfo" data-action="click->managerbase#showHideAddInfo" id="' + full.id +'" data-managerbase-id-param="' + full.id +'" data-managerbase-token-param="' + full.token +'"></span>'
                    })
                },
                {   data: 'id',
                    title: 'ID',
                    searchable: false,
                    orderable: false
                },
                {   data: 'client_name',
                    title: 'Имя',
                    searchable: true,
                    orderable: true
                },
                {   data: 'client_surname',
                    title: 'Фамилия',
                    searchable: true,
                    orderable: true
                },
                {   data: 'client_date_birth',
                    render: ((data, type, full, meta)=>{
                        return new Date(data).toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty" })
                    }),
                    title: 'Дата рождения',
                    searchable: true,
                    orderable: true
                },
                {   data: 'phone',
                    title: 'Телефон',
                    searchable: true,
                    orderable: true
                },
                /*            {   data: 'created_by',
                                render: ((data, type, full, meta)=>{
                                    let doctorName = self.doctors.filter(function(val) {
                                        return val.StaffID === data;
                                    });

                                    //console.debug(doctorName[0]);
                                    let createdDate = new Date(full.created_at);
                                    let createdDateDay = createdDate.getDate();
                                    let createdDateMonth = createdDate.getMonth() + 1;
                                    if(createdDateDay < 10) {
                                        createdDateDay = '0' + createdDateDay
                                    }
                                    if(createdDateMonth < 10) {
                                        createdDateMonth = '0' + createdDateMonth
                                    }
                                    createdDateDay = createdDateDay + '.' + createdDateMonth + '.' + createdDate.getFullYear();

                                    if (doctorName[0] !== undefined){
                                        return 'Дата регистрации: ' + createdDateDay + '<br>'
                                                + doctorName[0].Post + '<br>'
                                                + doctorName[0].Name
                                        //return doctorName[0].Name + ' (ID '+data+ ') '
                                    }
                                    return 'Дата регистрации: ' + createdDateDay + '<br>' +
                                        'Нет имени регистратора'
                                    //return 'Нет имени врача (ID '+data+ ')'
                                }),
                                title: 'Кто зарегистрировал',
                                searchable: true,
                                orderable: true,
                            },*/
                {

                    title: 'Сообщение',
                    orderable: false,
                    searchable: false,
                    data: null,
                    render: ((data, type, full, meta)=>{
                        let disabled = 'disabled="disabled"';
                        let disabledText = 'Создайте кабинет';
                        if (full.token !== null ){
                            disabled = '';
                            disabledText = 'Отправить сообщение'
                        }
                        return '<span  title="'+disabledText+'"> <button class="btn btn-datainfo"  data-bs-toggle="modal" data-bs-target="#sendMessage-' + full.id +'" title="'+disabledText+'" '+disabled+' id="sendMessageBtn-' + full.id +'"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-datainfo" ><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg> <!--отправить-->\n' +
                            '</button></span>' +
                            '<div class="modal fade" id="sendMessage-' + full.id +'" tabindex="-1" aria-hidden="true">' +
                            '<div class="modal-dialog modal-dialog-centered">' +
                            '<div class="modal-content">' +
                            '<div class="modal-header">' +
                            '<h5 class="modal-title">Отправить сообщение<br>'+ full.client_name +' '+ full.client_surname +'</h5><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"  data-action="managerbase#clearMessageForm" data-managerbase-idmessageform-param="' + full.id +'"></button>' +
                            '</div>' +
                            '<div class="modal-body">' +
                            '<form id="messageSend-' + full.id +'">' +
                            '<input type="hidden" name="client_id" id="clientId" required="" value="' + full.id +'">' +
                            '<input type="hidden" name="Icon" id="icon" value="/favicon/android-chrome-192x192.png" required="">' +
                            '<input type="hidden" name="phone" id="phoneWh" value="'+full.phone+'" required="">' +
                            '<div class="row g-3">' +
                            '<div class="col-12">' +
                            '<label for="title" class="form-label">Заголовок</label>' +
                            '<input type="text" class="form-control" id="messageTitle-' + full.id +'" placeholder="" required="" name="Title">' +
                            '<div class="invalid-feedback">Пожалуйста, заполните поле</div>' +
                            '</div>' +
                            '<div class="col-12">' +
                            '<label for="text" class="form-label">Текст (max 200 символов)</label>' +
                            '<textarea class="form-control" id="messageText-' + full.id +'" placeholder="" required=""  maxlength="200" name="Body"></textarea>' +
                            '<div class="invalid-feedback">Пожалуйста, заполните поле</div>' +
                            '</div>' +
                            '</div>' +
                            '</form>' +
                            '</div>' +
                            '<div class="modal-footer sendMessageBox" id="messageBtn-' + full.id +'">' +
                            '<button type="submit" class="btn btn-datainfo" data-action="click->managerbase#sendMessageWhatsapp"  data-managerbase-id-param="' + full.id +'"  id="messageWA-'+full.id+'"><svg width="64" height="64" class="icon icon-datainfo" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_206_68)"><path d="M32 0C14.3273 0 0 14.3273 0 32C0 37.9127 1.61055 43.4469 4.40909 48.1989L0.3125 63.5398L16.4034 59.9403C21.0187 62.5222 26.336 64 32 64C49.6727 64 64 49.6727 64 32C64 14.3273 49.6727 0 32 0ZM32 5.81818C46.4596 5.81818 58.1818 17.5404 58.1818 32C58.1818 46.4596 46.4596 58.1818 32 58.1818C26.5731 58.1818 21.5326 56.5307 17.3523 53.7045L8.4233 55.7017L10.696 47.1847C7.63711 42.8996 5.81818 37.6669 5.81818 32C5.81818 17.5404 17.5404 5.81818 32 5.81818ZM21.0511 17.071C20.5173 17.071 19.6592 17.2683 18.929 18.0625C18.2119 18.8581 16.1648 20.7692 16.1648 24.6761C16.1648 28.5685 18.9921 32.3444 19.3892 32.8636C19.7863 33.3975 24.8735 41.6571 32.9375 44.8324C39.6226 47.4651 40.9884 46.9435 42.4517 46.8068C43.9033 46.6817 47.1394 44.897 47.7983 43.0483C48.4558 41.1981 48.4551 39.6115 48.25 39.2784C48.0507 38.9555 47.53 38.755 46.7358 38.358C45.9416 37.9594 42.0455 36.0402 41.3153 35.7784C40.5953 35.5166 40.0619 35.3791 39.5426 36.1733C39.0088 36.9675 37.4955 38.7548 37.0227 39.2756C36.5645 39.8094 36.1067 39.8715 35.3125 39.4744C34.5183 39.0773 31.9644 38.2438 28.9375 35.5398C26.5826 33.4438 24.9923 30.8481 24.5341 30.0568C24.0745 29.2641 24.4836 28.8318 24.8807 28.4347C25.2414 28.0885 25.6768 27.515 26.0739 27.0568C26.4579 26.5855 26.5933 26.2639 26.8551 25.7301C27.13 25.2108 26.9904 24.738 26.7926 24.3409C26.5963 23.9424 25.0563 20.0224 24.3494 18.4602C23.756 17.1453 23.1355 17.1068 22.5653 17.0938C22.1043 17.0705 21.5704 17.071 21.0511 17.071Z" fill="#FDFDFD"/></g><defs><clipPath id="clip0_206_68"><rect width="64" height="64" fill="white"/></clipPath></defs></svg>  в  whatsapp</button>' +
                            '<button type="submit" class="btn btn-datainfo" data-action="click->managerbase#sendMessagePush"   data-managerbase-id-param="' + full.id +'"  id="messagePush-'+full.id+'"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 92.19" xmlns:v="https://vecta.io/nano" class="icon icon-datainfo-fill" ><path d="M78.37 9.74c-1.81 0-3.29-1.47-3.29-3.29 0-1.81 1.47-3.29 3.29-3.29 12.29 0 23.42 4.98 31.47 13.04 8.06 8.06 13.04 19.18 13.04 31.47s-4.98 23.42-13.04 31.47c-8.06 8.06-19.18 13.04-31.47 13.04-1.81 0-3.29-1.47-3.29-3.29s1.47-3.29 3.29-3.29c10.48 0 19.96-4.25 26.83-11.11 6.87-6.87 11.11-16.35 11.11-26.83s-4.25-19.96-11.11-26.83C98.33 13.98 88.84 9.74 78.37 9.74h0zm-67.9 12.02h24.27L55.4.97c1.28-1.28 3.35-1.29 4.63-.01.65.63.97 1.47.97 2.32h.01v85.49c0 1.81-1.47 3.29-3.29 3.29-.92 0-1.75-.38-2.35-.99L34.91 73.81H10.47a10.44 10.44 0 0 1-7.39-3.07C1.18 68.85 0 66.23 0 63.35V32.23a10.44 10.44 0 0 1 3.07-7.39c1.9-1.9 4.52-3.08 7.4-3.08h0zm25.62 6.57H10.47c-1.07 0-2.04.44-2.75 1.15s-1.15 1.68-1.15 2.75v31.12c0 1.07.44 2.04 1.15 2.75s1.68 1.15 2.75 1.15h25.62v.02c.74 0 1.49.25 2.1.77l16.25 13.69v-70.5L38.59 27.18c-.61.71-1.5 1.15-2.5 1.15h0zm40.62.19c-1.5 0-2.72-1.22-2.72-2.72s1.22-2.72 2.72-2.72c6.98 0 13.3 2.83 17.87 7.4s7.4 10.89 7.4 17.87-2.83 13.3-7.4 17.87-10.89 7.4-17.87 7.4c-1.5 0-2.72-1.22-2.72-2.72s1.22-2.72 2.72-2.72c5.48 0 10.44-2.22 14.03-5.81s5.81-8.55 5.81-14.03-2.22-10.44-5.81-14.03c-3.6-3.57-8.56-5.79-14.03-5.79h0z"/></svg>  в push</button>' +
                            '<button type="button" class="btn btn-danger" data-bs-dismiss="modal" data-action="managerbase#clearMessageForm"  data-managerbase-idmessageform-param="' + full.id +'">не отправлять</button>' +
                            '</div>' +
                            '</div>' +
                            '</div>' +
                            '</div>'

                    })
                },
                {

                    title: 'Покупки',
                    orderable: false,
                    searchable: false,
                    data: null,
                    render: ((data, type, full, meta)=>{
                        let loadPurchasesdateDateInfo;
                        if (full.sales_loaded_till === null) {
                            loadPurchasesdateDateInfo = 'никогда'
                        } else {
                            loadPurchasesdateDateInfo = new Date(Date.parse(full.sales_loaded_till)).toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty", hour: "2-digit", minute: "2-digit" })
                        }
                        let disabled = 'disabled="disabled"';
                        let disabledText = 'Создайте кабинет';
                        if (full.token !== null ){
                            disabled = '';
                            disabledText = 'Загрузить покупки'
                        }
                        return '<span title="'+disabledText+'"><button class="btn btn-datainfo" data-action="click->managerbase#loadPurchases" data-managerbase-token-param="' + full.token +'" data-managerbase-id-param="' + full.id +'" id="loadPurchases-' + full.id +'"  '+disabled+' ><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-datainfo"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg> <!--Загрузить-->\n' +
                            '</button></span> <span class="loadPurchasesdate" id="loadPurchasesdate-' + full.id +'">Последняя загрузка: <br>'+loadPurchasesdateDateInfo+'</span>'
                    })
                },
                {

                    title: 'Кабинет',
                    orderable: false,
                    searchable: false,
                    data: null,
                    render: ((data, type, full, meta)=>{
                        if(full.token === null){
                            return '<button class="btn btn-datainfo" data-action="click->managerbase#addCabinet" data-managerbase-idpatient-param="' + full.id +'" title="Создать кабинет клиенту" id="btnAddCabinet-'+full.id+'"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-datainfo"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg> <!--Создать-->\n' +
                                '</button>'
                        } else {
                            return '<span class="textExistСabinet"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg> Кабинет есть</span>' +
                                '<input class="copyLkInput" type="text" value="https://my.actualoptic.kz/?' + full.token +'" id="copyLk-' + full.token +'"><button class="btn btn-copyToken" id="inputTokenCopy" type="button" title="Копировать ссылку на кабинет" data-action="click->managerbase#copyLk"  data-managerbase-token-param="' + full.token +'"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-datainfo"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>' +
                                '' +
                                ' <!--Копировать--></button> '
                        }

                    })
                },
                {

                    title: 'Edit',
                    orderable: false,
                    searchable: false,
                    data: null,
                    render: ((data, type, full, meta)=>{
                        return '<span class="button-action" data-action="click->managerbase#editClient" data-managerbase-clientPhone-param="' + full.phone +'"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>\n' +
                            '</span>'
                    })
                },


            ],
        });
    }

    //dashboard
    dashboardData(){
        $('.counterSalonName').text(WhoIs.StoreCode);
        let currentDate = new Date().toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty" });

        $('#dailyCounter-CurrentDate').text(currentDate);
        $('#dailyCounter-CurrentDateInput').val(currentDate);


        let input = document.getElementById("inputTag");
        let imageName = document.getElementById("imageName")

        input.addEventListener("change", ()=>{
            let inputImage = document.querySelector("input[type=file]").files[0];

            imageName.innerText = inputImage.name;
        })
    }

    //count calendar period
    countPeriodData(even){
        let selectedPeriod = event.params.period;
        let today = new Date();
        let countDate = new Date(today);
        let currentDate = new Date(today).toLocaleDateString('ru-KZ');

        if (selectedPeriod === 'yesterday'){
            countDate = countDate.setDate(countDate.getDate() - 1);
        }  else if(selectedPeriod === 'week'){
            countDate = countDate.setDate(countDate.getDate() - 7);
        } else if(selectedPeriod === 'month'){
            countDate = countDate.setMonth(countDate.getMonth() - 1);
        } else if(selectedPeriod === 'quarter'){
            countDate = countDate.setMonth(countDate.getMonth() - 3);
        }
        countDate = new Date(countDate).toLocaleDateString('ru-KZ');
        $('.period-selector__period').text(countDate+' - '+currentDate);
    }

    //default calendar period = week ago
    defaultPeriodData(){
        $('.period-selector input[type="radio"][value="week"] + span').addClass('active');
        $('input[type="radio"]').on('change', function() {
            $('input[type="radio"]').not(this).next('span').removeClass('active');
            $(this).next('span').addClass('active');
        });

        //date period default = week
        let today = new Date();
        let currentDate = new Date(today).toLocaleDateString('ru-KZ');
        let countDate = new Date(today.setDate(today.getDate() - 7)).toLocaleDateString('ru-KZ');
        $('.period-selector__period').text(countDate+' - '+currentDate);
    }

    /* copy LK link */
    copyLk(event){
        let copyText = 'https://my.actualoptic.kz/?'+event.params.token;
        $('#copyLk-'+ event.params.token +'').select();
        document.execCommand("copy");
        alert("Ссылка на ЛК скопирована");
    }

    html5Qr(){
        let html5QrcodeScanner = new Html5QrcodeScanner(
            "reader",
            { fps: 10, qrbox: {width: 250, height: 250} },
            /* verbose= */ false);
       /* html5QrcodeScanner.render(this.onScanSuccess, this.onScanFailure);*/
        html5QrcodeScanner.render((decodedText, decodedResult)=>{
            $('input[type="search"]').val(decodedText.replace('+',''));
            $('#html5-qrcode-button-camera-stop').click();
            $('#btn-close').click();
            this.table.search(decodedText.replace('+','')).draw();
        }, (error) => {
            console.warn(`Code scan error = ${error}`);
        });
        $('#html5-qrcode-button-camera-permission').text('Запросить разрешения для камеры');
        $('#html5-qrcode-button-camera-start').text('Начать сканирование');
        $('#html5-qrcode-button-camera-stop').text('Закончить сканирование');
        $('#html5-qrcode-anchor-scan-type-change').text('Сканировать изображение');
    }

    html5QrStop(){
        $('#html5-qrcode-button-camera-stop').click();
    }


    /* !!!!!!!!!!!!!!! for scheduler !!!!!!!!!!!! */
    // data current
    buildTableSchedule(){
        $.fn.dataTable.ext.errMode = 'none';
        self =  this;

        //устанвливаем дефолтно текущий день
        this.dataBaseScheduleStart = new Date();
        this.dataBaseScheduleStart.setHours(11);
        this.dataBaseScheduleStart.setMinutes(0);
        this.dataBaseScheduleStart.setSeconds(0);

        this.dataBaseScheduleFinish = new Date();
        this.dataBaseScheduleFinish.setDate(this.dataBaseScheduleFinish.getDate()  + 14);
        this.dataBaseScheduleFinish.setHours(20);
        this.dataBaseScheduleFinish.setMinutes(0);
        this.dataBaseScheduleFinish.setSeconds(0);

        this.tableSchedule = $('#databaseMySchedule').DataTable({
            language: {
                url: 'data/dataTables.ru.json'
            },
            fixedHeader: false,
            lengthChange: false,
            searching: false,
            paging: false,
            info: false,
            bAutoWidth: false,
            //scrollCollapse: true,
            //scrollY: 300,
            deferRender:    true,
            scroller:       true,
            serverSide: true,
            processing: true,
            ajax: {
                url: global.api_url + '/schedule/datatable',
                headers: {'Authorization': 'Bearer '+ sessionStorage.getItem('token')},
                type: 'post',
                data: (data)=>{

                    data.Filter = {
                        'positivId': '82',
                        'start': Math.trunc(this.dataBaseScheduleStart.getTime() / 1000).toString(),
                        'finish': Math.trunc(this.dataBaseScheduleFinish.getTime() / 1000).toString(),
                    };

                    return JSON.stringify(data);
                },
                contentType: "application/json",
                error: (error)=>{
                    console.debug(error);
                }
            },
            columns: this.getColumnsDatatable()
        });

    }

    getColumnsDatatable(){
        let columns = [];
        columns.push({
            orderable: false,
            searchable: false,
            data: 't',
            name: 't',
            title: '',
            width: "10%",
            render: ((data, type, full, meta)=>{
                let scheduleDate = new Date(data);
                let daysWeek = [
                    'Вс',
                    'Пн',
                    'Вт',
                    'Ср',
                    'Чв',
                    'Пт',
                    'Сб'
                ];
                let months = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
                    "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];
                let n = scheduleDate.getDay();
                let scheduleDateHours  = scheduleDate.getHours();
                let scheduleDateMinutes  = scheduleDate.getMinutes();
                if (scheduleDateHours < 10) {
                    scheduleDateHours = "0" + scheduleDateHours;
                }
                if (scheduleDateMinutes < 10) {
                    scheduleDateMinutes = "0" + scheduleDateMinutes;
                }

                let scheduleOnlyTime =  scheduleDateHours + ":" + scheduleDateMinutes;

                if (scheduleDate.getHours() === 11){
                    return '<div class="scheduleDateBox">' +
                        '<div class="scheduleDateCalendar">' +
                        '<span class="scheduleDateBox__month">'+months[scheduleDate.getMonth()]+'</span>' +
                        '<span class="scheduleDateBox__date">'+scheduleDate.getDate()+'</span>' +
                        '<span class="scheduleDateBox__daysWeek">'+daysWeek[n]+'</span>' +
                        '</div>' +
                        '<span class="scheduleOnlyTime">'+scheduleOnlyTime+'</span>' +
                        '</div>'
                } else {
                    return '<div class="scheduleDateBox scheduleDateBoxSingle"><span class="scheduleOnlyTime">'+scheduleOnlyTime+'</span></div>'
                }

            })
        });


        self = this;
        let storeDoctorList = this.doctors.filter((val)=>{
            return val.StoreCode === self.StoreCode
        });

        if (storeDoctorList.length === 1){
            $('#collapseMySchedule__wrapper').css({"width":"50%"});
        }
        if (storeDoctorList.length === 2){
            $('#collapseMySchedule__wrapper').css({"width":"70%"});
        }
        if (storeDoctorList.length > 2){
            $('#collapseMySchedule__wrapper').css({"width":"100%"});
        }



    storeDoctorList.forEach((item)=>{
        self = this;
        let colTitle = '<span class="">'+item.Name.replace(/(\S+) (\S+) (\S+)/, "$1  $2  $3")+'</span>';
        columns.push({
            data: 'd'+ item.StaffID,
            title: colTitle,
            searchable: false,
            orderable: false,
            width: "40%",
            render: ((data, type, full, meta)=>{
                 let statusDoctorName = '';
                let statusDoctorClass ='';
                let orderInfo = '';
                let collapseDoctorOff = '';
                let orderDateTimeFrom = new Date(full.t).getTime();
                let orderDateTimeTo = Number(orderDateTimeFrom) + 60 * 60 * 1000;

                //настройки локализации
                const dayOption = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
                const timeOption = { hour: "2-digit", minute: "2-digit" };
                //это дата
                let orderDateDayToUser = new Date(Number(orderDateTimeFrom));
                orderDateDayToUser = orderDateDayToUser.toLocaleDateString('ru-KZ', dayOption);
                //время от и до
                let orderDateFromTimeToUser = new Date(Number(orderDateTimeFrom));
                orderDateFromTimeToUser = orderDateFromTimeToUser.toLocaleTimeString('ru-KZ', timeOption);
                let orderDateToTimeToUser = new Date(Number(orderDateTimeTo));
                orderDateToTimeToUser = orderDateToTimeToUser.toLocaleTimeString('ru-KZ', timeOption);


                if (data.ClientsCustomerID === null && data.ClientsStaffID === null && data.Reason === 'offDays'){
                    statusDoctorName = '<span title="ВЫХОДНОЙ"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg></span>';
                    statusDoctorClass = 'offDays';
                    collapseDoctorOff = 'collapseDoctorOff';
                }
                if (data.ClientsCustomerID === null && data.ClientsStaffID === null && data.Reason === null){
                    statusDoctorName = '<span title="СВОБОДНОЕ РАБОЧЕЕ ВРЕМЯ"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg></span>';
                    statusDoctorClass = 'free';
                    orderInfo = '' +
                        '<strong class="datatableDoctorOrderInfo__title">Заблокировать время</strong>' +
                        '<ul class="datatableDoctorOrderInfo__list">' +
                        '<li>'+item.Name+'</li>' +
                        '<li>'+orderDateDayToUser+'</li>' +
                        '<li>с '+orderDateFromTimeToUser+' по '+orderDateToTimeToUser+'</li>' +
                        '</ul>' +
                        '<form id="blockTime-'+meta.col+''+meta.row+'">' +
                        '<div class="form-group datatableDoctorOrderInfo__form-group">' +
                        '<label>Причина</label>' +
                        '<input type="hidden" name="doctorId" value="'+item.StaffID+'">' +
                        '<input type="hidden" name="positivId" value="82">' +
                        '<input type="hidden" name="orderDateTimeFrom" value="'+orderDateTimeFrom+'">' +
                        '<input type="hidden" name="orderDateTimeTo" value="'+orderDateTimeTo+'">' +
                        '<input type="text" name="reason" value="" class="form-control form-control-sm"> ' +
                        '<button class="btn btn-primary btn-sm" type="button" data-action="click->managerbase#blockTime" data-managerbase-id-param="'+meta.col+''+meta.row+'" data-managerbase-row-param="'+meta.row+'">заблокировать</button>' +
                        '</div> ' +
                        '</form>' +
                        '<a href="https://actualoptic.kz/index.php?route=extension/actualoptic/branches/staff&staff_id='+item.StaffID+'&manager='+global.WhoIs.StaffID+'" target="_blank" class="datatableDoctorOrderInfo__link"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg> Записать клиента к врачу</a>'

                }
                if (data.ClientsCustomerID !== null && data.ClientsCustomerID !== '' && data.Type === 'BUSINESS'){
                    let ClientName = data.Reason.replace(/(\S+) (\S+) (\S+). (\S+): (\S+) (\S+) (\S+)/, "$5 $6");
                    let ClientPhone = data.Reason.replace(/(\S+) (\S+) (\S+). (\S+): (\S+) (\S+) (\S+)/, "$7");
                    let diagnosticType = '';
                    let isApprovedText = '';
                    let amauntIcon = '';
                    let switchStatus = '';
                    if(data.IsApproved){
                        isApprovedText = 'подтвержден';
                        statusDoctorClass = 'isApproved'
                        switchStatus = 'checked'
                    } else {
                        isApprovedText = 'не подтвержден';
                        statusDoctorClass = 'noApproved'
                    }
                    diagnosticType = global.globalFuncs.DiagnosticTypes.getDiagnosticTypeTitle(data.DiagnosticType)
                    if (data.PrepayAmount !== null){
                        amauntIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#212529" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon amauntIcon"><circle cx="12" cy="12" r="10"></circle><line x1="10" y1="15" x2="10" y2="9"></line><line x1="14" y1="15" x2="14" y2="9"></line></svg>'
                    }


                    statusDoctorName = '<span title="ЗАПИСЬ"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg></span>' +
                        amauntIcon;
                    let prepayAmountText = data.PrepayAmount;
                    if (prepayAmountText === null){
                        prepayAmountText = '';
                    }
                    orderInfo = '' +
                        '<strong class="datatableDoctorOrderInfo__title">Информация</strong>' +
                        '<ul class="datatableDoctorOrderInfo__list">' +
                        '<li>'+item.Name+'</li>' +
                        '<li><strong>Пациент</strong><br>'+ClientName+'<br>'+ClientPhone+'</li>' +
                        '<li><strong>Дата и время</strong><br> '+orderDateDayToUser+'<br>с '+orderDateFromTimeToUser+' по '+orderDateToTimeToUser+'</li>' +
                        '<li>'+diagnosticType+'</li>' +
                        '<li><strong>Прием:</strong><br>' +
                        '<div class="form-check form-switch">' +
                        '<input class="form-check-input" type="checkbox" role="switch" id="isApproved-'+meta.col+''+meta.row+'" value="'+data.IsApproved+'"  data-action="change->managerbase#isApproved" data-managerbase-dataid-param="'+data.ID+'"  data-managerbase-row-param="'+meta.row+'" '+switchStatus+'>\n' +
                        '  <label class="form-check-label" for="isApproved-'+meta.col+''+meta.row+'">'+isApprovedText+'</label>' +
                        '</div>' +
                        '</li>' +
                        '<li class="prepayAmountBox">' +
                        '<form id="prepaidForm-'+meta.col+''+meta.row+'">' +
                        '<div class="prepayAmountBox__form">' +
                        '<label>Аванс (KZT):</label>' +
                        '<input class="form-control form-control-sm prepayAmountBox-control" name="sum" type="text" id="prepaid-'+meta.col+''+meta.row+'" value="'+prepayAmountText+'">' +
                        '<input type="hidden" name="orderId" value="'+data.ID+'">' +
                        '<button  type="button" class="btn btn-primary btn-sm" data-action="click->managerbase#setPrepaid" data-managerbase-id-param="'+meta.col+''+meta.row+'" data-managerbase-row-param="'+meta.row+'">ok</button>' +
                        '</div>' +
                        '</form>' +

                        '</li>' +
                        /*'<li class="visit-btn">' +
                            '<button class="btn btn-primary btn-sm" type="button" >начался</button>' +
                            '<button class="btn btn-primary btn-sm" type="button" >завершен</button>' +
                        '</li>' +*/
                        '</ul>';

                }
                if(data.ClientsCustomerID !== null && data.ClientsCustomerID !== '' && data.Type === 'PERSONAL'){
                    statusDoctorName = '<span title="РАБОЧЕЕ ВРЕМЯ ЗАБЛОКИРОВАНО"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg></span>';
                    statusDoctorClass = 'block';
                    orderInfo = '' +
                        '<strong class="datatableDoctorOrderInfo__title">Время заблокировано </strong>' +
                        '<ul class="datatableDoctorOrderInfo__list">' +
                        '<li>'+item.Name+'</li>' +
                        '<li>'+orderDateDayToUser+'</li>' +
                        '<li>с '+orderDateFromTimeToUser+' по '+orderDateToTimeToUser+'</li>' +
                        '</ul>' +
                        '<div class="form-group datatableDoctorOrderInfo__form-group"><strong>'+data.Reason+'</strong></div>'
                }


                //создаем куда все положим
                return '<div class="datatableDoctorOrderBox" >' +
                    '<strong class=""></strong>' +
                    '<div class="collapseDoctor datatableDoctorOrderStatus datatableDoctorOrderStatus-'+statusDoctorClass+'">' +
                    '<input type="radio" name="collapseDoctorCheck" class="togCheck" id="check-'+meta.col+''+meta.row+'">' +
                    '<label for="check-'+meta.col+''+meta.row+'">'+statusDoctorName+'</label>' +
                    '<div class="datatableDoctorOrderInfo" id="datatableDoctorOrderInfo-'+meta.col+''+meta.row+'"><span class="close" id="close-'+meta.col+''+meta.row+'" data-action="click->managerbase#closeNote" data-managerbase-id-param="'+meta.col+''+meta.row+'"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#212529" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class=""><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg></span>\n' +
                    orderInfo +
                    '</div>' +
                    '</div>' +

                    '  </div>\n' +
                    '</div>' +
                    '</div>'



            })
        });
    })
        return columns
}

    blockTime(event){
        let blockTimeData = $($('#blockTime-'+event.params.id)[0]).serializeObject();
        if (blockTimeData.reason === ''){
            $('#blockTime-'+event.params.id+' label').append('<strong id="blockTimeAlert-'+event.params.id+'" style="color: red; display: inline-block; padding-left: 10px">заполните поле!</strong>');
            setTimeout(function() {
                    $('#blockTimeAlert-'+event.params.id).remove();
                },
                5000);
        } else {
            let result = api.blockTime(blockTimeData);
            $('#check-'+event.params.id).prop('checked', false);
            if (result.Status === 200 ){
                this.tableSchedule.row(event.params.row).invalidate().draw();
            }
        }

    }

    setPrepaid(event){
        let prepaid = $($('#prepaidForm-'+event.params.id)[0]).serializeObject();
        if (prepaid.sum === ''){
            $('#prepaidFormAlert-'+event.params.id).remove();
            $('#prepaidForm-'+event.params.id).append('<strong id="prepaidFormAlert-'+event.params.id+'" style="color: red; display: flex; width: 100%; padding:3px 0 0">заполните поле!</strong>');
            setTimeout(function() {
                    $('#prepaidFormAlert-'+event.params.id).remove();
                },
                5000);
            return
        }
        const hasOnlyDigits = (v) => /^\d+$/.test(v);

        if(!hasOnlyDigits(Number(prepaid.sum))){
            $('#prepaidFormAlert-'+event.params.id).remove();
            $('#prepaidForm-'+event.params.id).append('<strong id="prepaidFormAlert-'+event.params.id+'" style="color: red; display: flex; width: 100%; padding:3px 0 0">только цифры!</strong>');
            setTimeout(function() {
                    $('#prepaidFormAlert-'+event.params.id).remove();
                },
                5000);
            return
        }

        let result = api.setPrepaid(prepaid.orderId, prepaid.sum);
        $('#check-'+event.params.id).prop('checked', false);
        if (result.Status === 200 ){
            this.tableSchedule.row(event.params.row).invalidate().draw();
        }
    }

    isApproved(event){
        let result = api.isApproved(event.params.dataid);
        if (result.Status === 200 ){
            this.tableSchedule.row(event.params.row).invalidate().draw();
        }
    }

    closeNote(event){
        $('#check-'+event.params.id).prop('checked', false);
    }

    infoMySalonSchedule(){
        let start = this.dataBaseScheduleStart.toLocaleDateString('ru-KZ');
        let finish = this.dataBaseScheduleFinish.toLocaleDateString('ru-KZ');

        $('#collapseMySalonSchedule').html(global.WhoIs.StoreCode+' с '+start.replace(/(\d+).(\d+).(\d+)/, "$1.$2")+' по '+finish.replace(/(\d+).(\d+).(\d+)/, "$1.$2")+' ');

    }

    /* big filter */
 /*   getBrandsFilter(){
        let managerFilterBrand = $('#managerFilter-brand');
        let managerFilterBrandList = this.doctors = api.doctorList('doctor');
        managerFilterBrandList.forEach((item)=>{
            managerFilterBrand.append('<option value="'+item.StaffID+'">'+item.Name+' ('+item.StoreCode+')</option>');
        })
        managerFilterBrand.select2({
            placeholder: 'Нажмите, чтобы выбрать бренд'
        });
    }

    getModelsFilter(){
        let managerFilterModel = $('#managerFilter-model');
        let managerFilterModelList = this.doctors = api.doctorList('doctor');
            managerFilterModelList.forEach((item)=>{
            managerFilterModel.append('<option value="'+item.StaffID+'">'+item.Name+' ('+item.StoreCode+')</option>');
        })
            managerFilterModel.select2({
            placeholder: 'Нажмите, чтобы выбрать бренд'
        });
    }*/


    connect(){

        // we turn to twig, indicate which controller to use, inside we transfer the data
        let content = Twig.twig({ref: "managerbase"}).render({});

        let token = sessionStorage.getItem('token');
        if (token === null ){
            this.logout();
        }

         //specify the block and display the contents of the twig in it
        $('#managerbase').html(content);

        //create a list of doctors in the select
        this.getDoctorsList();

       //output database
        this.buildTable();


        if (WhoIs.Type === 'office'){
            this.clearFilter();
        }

        //QR scan
        this.html5Qr();

        /* sheduler */
        this.StoreCode = WhoIs.StoreCode;
        this.buildTableSchedule();
        this.infoMySalonSchedule();

        /* big filter */
        //for date field
/*        let self = this;
        $.datetimepicker.setLocale('ru');
        $('#managerFilter-start').datetimepicker({
            timepicker:false,
            format:'d.m.Y',
            maxDate:'+1970/01/01'//today is maximum date calendar
        });

        $('#managerFilter-finish').datetimepicker({
            timepicker:false,
            format:'d.m.Y',
            maxDate:'+1970/01/01'//today is maximum date calendar
        });*/

      /*  this.getBrandsFilter();
        this.getModelsFilter();*/
    }
}
